<template>
  <div>
    <h3>
      <label :for="name">{{ label }}</label>
      <span v-if="required" class="required-field">*</span>
    </h3>
    <Field
      :name="name"
      type="text"
      v-model="inputValue"
      v-slot="{ errorMessage, meta, handleBlur }"
    >
      <input
        :id="name"
        name="input"
        :class="{ error: errorMessage && meta.touched }"
        :type="type"
        :placeholder="placeholder"
        :value="inputValue"
        :disabled="disabled"
        @blur="handleBlur"
        @input="$emit('update:value', $event.target.value)"
      />
      <ErrorMessage v-if="meta.touched" class="errorMsg" :name="name" as="p" />
    </Field>
  </div>
</template>

<script>
import { computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";

export default {
  name: "InputText",
  props: {
    label: {
      type: String,
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
    },
  },
  components: { Field, ErrorMessage },
  setup(props, { emit }) {
    const inputValue = computed({
      get() {
        return props.value;
      },
      set(inputValue) {
        emit("update:value", inputValue);
      },
    });
    return { inputValue };
  },
};
</script>
